import React from "react";
import FormLabel from "@mui/material/FormLabel";
import {
  LocalizationProvider,
  TimePicker,
  TimePickerProps,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

import "@/utils/dayjs-config";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("UTC");

export interface IInput extends TimePickerProps {
  label?: React.ReactNode;
  errorText?: any;
  labelStyle?: React.CSSProperties;
  id?: string;
}

function TimeInputComponent({
  label,
  errorText,
  disabled,
  labelStyle,
  id,
  ...rest
}: IInput) {
  const [open, setOpen] = React.useState(false);
  const generatedId = React.useId().replace(/[^a-zA-Z0-9_-]/g, "");
  const inputId = id || `time-picker-${generatedId}`;

  return (
    <>
      {label && (
        <FormLabel
          htmlFor={inputId}
          sx={{
            color: "#1F4970",
            fontSize: "14px",
            fontWeight: "600",
            padding: "12px 4px",
            ...labelStyle,
          }}
        >
          {label}
        </FormLabel>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          className="date_picker_error"
          timezone="UTC"
          disabled={disabled}
          {...rest}
          sx={[
            {
              width: "100%",
              "& .MuiOutlinedInput-root": {
                fontSize: "0.875rem",
              },
            },
            errorText
              ? {
                  "& .MuiOutlinedInput-root": {
                    borderColor: "#FF0000",
                  },
                }
              : {
                  "& .MuiOutlinedInput-root": {
                    borderColor: "",
                  },
                },
            errorText
              ? {
                  "& .MuiOutlinedInput-root": {
                    color: "#FA896B",
                  },
                }
              : {
                  "& .MuiOutlinedInput-root": {
                    color: " #1F4970",
                  },
                },
            errorText
              ? {
                  "& .MuiOutlinedInput-root": {
                    border: "1px solid #F00",
                  },
                }
              : {
                  "& .MuiOutlinedInput-root": {
                    border: "",
                  },
                },
          ]}
          timeSteps={{
            minutes: 1,
          }}
          ampm={false}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          slotProps={{
            textField: {
              error: errorText,
              helperText: errorText,
              style: {
                color: errorText ? "#F00" : "#000",
              },
              onClick: () => !disabled && setOpen(true),
              id: inputId,
              name: inputId,
            },
          }}
        />
      </LocalizationProvider>
    </>
  );
}

export default TimeInputComponent;
